<div class="container-fluid">
  <div *ngIf="loading; else loaded">
    <app-loading></app-loading>
  </div>

  <ng-template #loaded>
    <h1 class="h3 mb-2 text-gray-800">Incomes</h1>

    <div class="card shadow mb-4">
      <div class="card-body">
        <button
          href="#add"
          role="button"
          data-toggle="modal"
          class="btn btn-success btn-icon-split"
        >
          <span class="icon text-white-50">
            <i class="fas fa-plus"></i>
          </span>
          <span class="text">{{ incomeI18n?.addButtonI18n }}</span>
        </button>
        <div class="table-responsive">
          <app-income-list
            [incomeI18n]="incomeI18n"
            [incomes]="incomes$"
            (deleteEvent)="delete($event)"
          ></app-income-list>
          <app-modal-income [incomeI18n]="incomeI18n"></app-modal-income>
        </div>
      </div>
    </div>
  </ng-template>
</div>
